module.exports = __webpack_public_path__ + "static/media/Florida_Panthers.181c6ad0.svg";